import React, { useState } from "react"
import { useHistory } from "react-router"
import { SurveyCreatorComponent, SurveyCreator } from 'survey-creator-react';
import PropTypes, { InferProps } from 'prop-types';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';
import Toast from "components/Toast";
import { patchFormTemplate } from "core/services/api";
import { StylesManager } from "survey-react";

StylesManager.applyTheme('defaultV2');

/**
 * Renders form template editor UI.
 * 
 * @param this 
 * @param props {json: any, part: number, id: string}
 * @returns 
 */
function SurveyCreatorWidget(this: any, props: InferProps<typeof SurveyCreatorWidget.propTypes>) {
  const history = useHistory()
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [loading, toggleLoading] = useState<boolean>(false)
  const [templateJson, setTemplateJson] = useState<any>(null)

  // render form editor
  let options = { showLogicTab: true, showTranslationTab: false }
  let creator = new SurveyCreator(options)
  creator.JSON = templateJson ? templateJson : props.json;

  // assign create / update function
  /**
   * Gets triggers on "Save" of an edited / created form template. 
   * 
   * <ul>
   *    <li>Updates state of the component with the updated form template JSON,</li>
   *    <li>Calls API to update form template JSON in datastore.</li> 
   * </ul>
   * 
   * @param no Edit version number (only within UI)
   * @param callback Callback function (will be provided by Survey Core)
   */
  let saveSurveyFunc = (no: number, callback: Function) => {
    setTemplateJson(creator.JSON);
    // toggleLoading(true);
    let input = {
      dataToUpdate: [
        {
          part: props.part ? props.part : null,
          json: creator.JSON
        }
      ]
    };
    patchFormTemplate(props.id, input).then((res: any) => {
      toggleLoading(false);
      toggleDisplayToast({
        type: "success",
        text: "Form updated successfully!"
      });
    }).catch((err: any) => {
      toggleLoading(false);
      console.log(err, "error");
      toggleDisplayToast({
        type: "failure",
        text: "Form updated failed!"
      });
    })
  };
  creator.saveSurveyFunc = saveSurveyFunc;

  return (
    <div>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>)
      }
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              history.goBack()
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
      <SurveyCreatorComponent creator={creator} />
    </div >
  );
}

/**
 * Defines props for the component.
 */
SurveyCreatorWidget.propTypes = {
  json: PropTypes.any,
  part: PropTypes.number,
  id: PropTypes.string.isRequired
};

export default SurveyCreatorWidget;
